import { render, staticRenderFns } from "./gestionNoticiaCard.vue?vue&type=template&id=86c95616&scoped=true"
import script from "./gestionNoticiaCard.vue?vue&type=script&lang=js"
export * from "./gestionNoticiaCard.vue?vue&type=script&lang=js"
import style0 from "./gestionNoticiaCard.vue?vue&type=style&index=0&id=86c95616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c95616",
  null
  
)

export default component.exports